import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CardComponent from "./CardComponent.jsx";
import alerts from "../../assets/img/landing/alerts.svg";
import alerts_and_management from "../../assets/img/landing/alerts_and_management.svg";
import summary from "../../assets/img/landing/summary.svg";
import management from "../../assets/img/landing/management.svg";
import insights from "../../assets/img/landing/insights.svg";
import havi_symbol from "../../assets/img/landing/havi_symbol.svg";
import mcd_symbol from "../../assets/img/landing/mcd_symbol.svg";
import qualityRisks from "../../assets/img/landing/qualityRisks.png";
import managedata from "../../assets/img/landing/manageData.svg";

import "../../assets/css/custom.css";
import ExternalTools from "./ExternalTools.jsx";
import ExternalLink from "./ExternalLink.jsx";
import { useSelector } from "react-redux";
import { modulesKeyMap } from "../AuthConfig/actionMap.js";

const externalLinks = [
  {
    icon: havi_symbol,
    text: "Supply Chain Visibility",
    link: "https://connect.havi.com/app/scp",
  },
  {
    icon: havi_symbol,
    text: "Virtual Situation Room",
    link: "https://connect.havi.com/app/vsr/situation-rooms",
  },
  {
    icon: havi_symbol,
    text: "HAVI Event",
    link: "https://mcd.event-optimizer.havi.com/event",
  },
  {
    icon: havi_symbol,
    text: "Product Book Journey",
    link: "https://connect.havi.com/app/pbj/productbook",
  },
  {
    icon: havi_symbol,
    text: "Contingency Waterfall",
    link: "https://myhavi.sharepoint.com/:f:/s/ProjectIlluminate-InternalSite/EgCNGfWln45LhzkJc_yc3q8BwG4YAKSxUs8x__DlYmZT3g?e=9ScxW0",
  },
  {
    icon: mcd_symbol,
    text: "Amabis",
    link: "https://gsc.amabis-timeware.eu/login",
  },
  {
    icon: mcd_symbol,
    text: "CapCon",
    link: "https://contingency.mcd.com/",
  },
];

const LandingPage = ({ setPageHeader }) => {
  const authInfo = useSelector((state) => state.user.authInfo);
  
  return (
    <div>
      <div className="container">
        <div className="landing_hdr">
          <div className="landing_hdr_txt_gray">
            Risk Management tool is developed to anticipate and mitigate supply
            chain risk, it helps to monitor, assess, and mitigate supplier
            risks.
          </div>
        </div>
        <div className="landing-module">Modules</div>
        <Row>
          {authInfo.moduleAuthKeys.indexOf(modulesKeyMap.OPERATIONAL) > -1 && (<Col className="col-sm-4 landing-col">
            <CardComponent
              topImage={summary}
              title="Operational Risk"
              link="/Summary"
              description="See - Executive Overview of Current & Emerging Risks within the Supply Chain."
              logo="_workflow"
              btnLink="nav"
              btnName="Operational Risk"
              onClickBtn={setPageHeader}
            />
          </Col>)}

          {authInfo.moduleAuthKeys.indexOf(modulesKeyMap.STRATEGIC) > -1 && (<Col className="col-sm-4 landing-col">
            <CardComponent
              topImage={alerts_and_management}
              title="Strategic Risk"
              link="/StrategicSummary"
              description="Understand & Act - ability to action risks, update status, explore mitigation options, and track a risk case to completion."
              logo="_alerts"
              btnLink="nav"
              btnName="Strategic Risk"
              onClickBtn={setPageHeader}
            />
          </Col>)}

          {/* <Col className="col-sm-3 landing-col">
            <CardComponent
              topImage={management}
              title="Risk Management (Act)"
              link="/closedRisks"
              description="Access individual open risk to understand mitigation options & take actions towards closure."
              logo="_closed_Events"
              btnLink="nav"
              btnName="Visit Module"
              onClickBtn={setPageHeader}
            />
          </Col> */}
          {authInfo.moduleAuthKeys.indexOf(modulesKeyMap.RISK_INSIGHTS) > -1 && (<Col className="col-sm-4 landing-col">
            <CardComponent
              topImage={insights}
              title="Risk Insights"
              link="/insight"
              description="Learn - receive historical insights based on past risks & resolutions to continuously improve & apply proactive measures."
              logo="_historical_Insights"
              btnLink="nav"
              btnName="Risk Insights"
              onClickBtn={setPageHeader}
            />
          </Col>)}

        </Row>
        <Row style={{ justifyContent: "center"}}>
          {authInfo.moduleAuthKeys.indexOf(modulesKeyMap.QUALITY_RISKS) > -1 && (<Col className="col-sm-4 col-sm-offset-2 landing-col">
            <CardComponent
              topImage={qualityRisks}
              title="Quality Complaints"
              link="/QualityCPM"
              description="Learn - receive historical insights based on past risks & resolutions to continuously improve & apply proactive measures."
              logo="_historical_Insights"
              btnLink="nav"
              btnName="Quality Risk"
              onClickBtn={setPageHeader}
              imageClassName="svg-white-img"
            />
          </Col>)}

          {authInfo.moduleAuthKeys.indexOf(modulesKeyMap.MANAGE_DATA) > -1 && (<Col className="col-sm-4 landing-col">
            <CardComponent
              topImage={managedata}
              title="Manage Data"
              link="/ManageData"
              description="Learn - receive historical insights based on past risks & resolutions to continuously improve & apply proactive measures."
              logo="_historical_Insights"
              btnLink="nav"
              btnName="Manage Data"
              onClickBtn={setPageHeader}
            />
          </Col>)}
        </Row>

        <div>
          <div className="landing-module">External Links</div>
          <div className="ext-links-wrapper">
            {externalLinks.map(({ icon, text, link }) => {
              return (
                <ExternalLink key={text} icon={icon} text={text} link={link} />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
